<template src="../templates/normal_fcont_84.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreatorProfileVosges from '../components/CreatorProfileVosges'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   CreatorProfileVosges,PrintButton,UseDesignPaperList
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['84-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['84-2']}
    ]};
  }
};
</script>
<style />


